import { ConversationList } from '@/components/chat/ConversationList';
import { PostList } from '@/components/facebook/post-list';
import { AutomateResponseList } from '@/components/sale/AutomateResponseList';
import { CustomerWaitingList } from '@/components/sale/CustomerWaitingList';
import { LiveVideoList } from '@/components/sale/LiveVideoList';
import { SaleTabKey } from '@/pages/sale/lib/sale-tab-config';
import { AutoReply, FbConversation, FBLive, FBPost, QueueCustomer } from '@/types/fb-type';

type SaleSidebarTabPanelProps = {
  activeTab: SaleTabKey;
  conversations: FbConversation[];
  loadingConversations: boolean;
  onConversationSelect: (conversation: FbConversation) => void;
  posts: FBPost[];
  isLoadingPost: boolean;
  onPostSelect: (post: FBPost) => void;
  fbLives: FBLive[];
  loadingFbLives?: boolean;
  onSelectLiveVideo: (fbLive: FBLive | null) => void;
  autoReplies: AutoReply[];
  queueCustomers: QueueCustomer[];
  onSelectQueueCustomer: (customer: QueueCustomer) => void;
  onDropProductOnQueueCustomer?: (
    customer: QueueCustomer,
    productId: string,
    variantId: string,
  ) => void;
};

export function SaleSidebarTabPanel({
  activeTab,
  conversations,
  loadingConversations,
  onConversationSelect,
  posts,
  isLoadingPost,
  onPostSelect,
  fbLives,
  loadingFbLives,
  onSelectLiveVideo,
  autoReplies,
  queueCustomers,
  onSelectQueueCustomer,
  onDropProductOnQueueCustomer,
}: SaleSidebarTabPanelProps) {
  return (
    <div className="flex-1 overflow-x-hidden">
      {activeTab === 'inbox' && (
        <ConversationList
          onSelect={onConversationSelect}
          items={conversations}
          isLoading={loadingConversations}
        />
      )}

      {activeTab === 'post' && (
        <PostList posts={posts} isLoading={isLoadingPost} onSelect={onPostSelect} />
      )}

      {activeTab === 'live' && (
        <LiveVideoList lives={fbLives} onSelect={onSelectLiveVideo} isLoading={loadingFbLives} />
      )}

      {activeTab === 'auto' && (
        <AutomateResponseList autoReplies={autoReplies} onSelect={() => {}} />
      )}

      {activeTab === 'waiting' && (
        <CustomerWaitingList
          participants={queueCustomers}
          onSelect={onSelectQueueCustomer}
          onDropProduct={onDropProductOnQueueCustomer}
        />
      )}
    </div>
  );
}
